module.exports = __webpack_public_path__ + "img/person-4.b622fbda.jpg";